const questions = [
  {
    id: 1,
    question: "축제를 즐기러 나는?",
    answers: [
      {
        type: 0,
        answer: "그날 가면 어떻게든 되겠지. 혼자 왔다.",
      },
      {
        type: 1,
        answer: "이미 약속 잡아뒀지! 친구와 함께 왔다.",
      },
    ],
  },
  {
    id: 2,
    question: "축제에는 포토스팟이 빠질 수 없지!\n사진을 찍어야겠다. 나는?",
    answers: [
      {
        type: 0,
        answer: "풍경 사진만 찍는다.",
      },
      {
        type: 1,
        answer:
          "내가 안 나오면 내 추억 사진이 아니야!\n나 좀 찍어줘~ 같이 사진 찍자!",
      },
    ],
  },
  {
    id: 3,
    question: "축제 거리를 구경하고 있는데,\n어! 저기! 고양이가 보인다.",
    answers: [
      {
        type: 0,
        answer: "만지지 않고 눈으로만 본다.",
      },
      { type: 1, answer: "다가가서 궁디팡팡을 해준다." },
    ],
  },
  {
    id: 4,
    question: "'여기 들렀다 가세요!'\n눈 앞에 많은 부스가 있다.",
    answers: [
      {
        type: 0,
        answer: "제일 가까운 부스부터 간다.",
      },
      {
        type: 1,
        answer: "팜플렛으로 미리 눈여겨 본 부스로 간다.",
      },
    ],
  },
  {
    id: 5,
    question: "부스를 모두 참여하면\n사은품을 준다고 한다!",
    answers: [
      {
        type: 0,
        answer: "귀찮다. 하고 싶은 것만 골라서 참여한다.",
      },
      {
        type: 1,
        answer: "모두 참여해서 사은품을 받을거다.",
      },
    ],
  },
  {
    id: 6,
    question: "잔디광장에\n쉴 수 있는 빈백들이 보인다.",
    answers: [
      {
        type: 0,

        answer: "빈백에 잠시 앉아 일광욕을 즐긴다.",
      },
      {
        type: 1,
        answer: "즐길거리도 많은데 앉아있을 시간이 없지!\n구경하러 돌아다닌다.",
      },
    ],
  },
  {
    id: 7,
    question:
      "다양한 음식의 푸드트럭들이 많다!\n내가 먹고 싶은 음식의 푸드트럭은\n인기가 많아서 오래 기다려야할 것 같다.",
    answers: [
      {
        type: 0,
        answer: "피해서 그냥 다른 음식을 먹는다.",
      },
      {
        type: 1,
        answer: "그래도 내가 원하는 거 먹어야지! 기다린다.",
      },
    ],
  },
  {
    id: 8,
    question: "오늘 축제에는\n인기 가수의 공연이 예정되어있다.",
    answers: [
      {
        type: 0,
        answer: "굳이 봐야할까?\n피곤하지 않게 집에 간다.",
      },
      {
        type: 1,
        answer: "그 가수 팬이 아니더라도\n이 공연은 봐야겠다.",
      },
    ],
  },
  {
    id: 9,
    question: "공연까지는 보기로 했다.\n나는 노래를 들으며",
    answers: [
      {
        type: 0,
        answer: "조용히 감상한다.",
      },
      {
        type: 1,
        answer: "훠~~~ 최선을 다해 호응한다.",
      },
    ],
  },
  {
    id: 10,
    question: "축제를 모두 즐기고\n드디어 집에 도착했다.",
    answers: [
      {
        type: 0,
        answer: "피곤하다.. 빨리 씻고 잔다.",
      },
      {
        type: 1,
        answer:
          "오늘 찍은 사진을 정리하고,\n오늘에 대한 내용을 다이어리에 쓴다.",
      },
    ],
  },
  {
    id: 11,
    question: "오늘 축제 너무 재미있었다!\n내일 축제는?",
    answers: [
      {
        type: 0,
        answer: "오늘 즐겼으면 됐지 뭐~",
      },
      {
        type: 1,
        answer: "무조건 가야지!! 전일 참석",
      },
    ],
  },
];

export default questions;
